import Button from "components/button/Button";
import { PROVINCES_MAPPING } from "constants/Constants";
import { apiSignUpClinic } from "helpers/api/clinic";
import Loading from "components/loading/Loading";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { showToastError } from "utils";

import { Col, Flex, Row } from "antd";


const ConfirmSignUp = ({ setScreen, values = {} }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);
    const res = await apiSignUpClinic({
      email: values.email,
      password: values.password,
      clinic_name: values.clinic_name,
      clinic_name_furigana: values.clinic_name_furigana,
      address: values.address,
      email: values.email,
      phone_number: values.phone_number,
    });
    if (res.data) {
      setScreen(2);
    } else if (res?.error?.reason) {
      showToastError(`messages.${res?.error?.reason}`);
    }
    setIsLoading(false);
  };

  return (
    <div className="clinic-container">
      <div className="clinic-title">{t("signUp.confirmPage.title")}</div>

      <Row gutter={[16, 16]} align="middle" style={{ flexWrap: "wrap" }}>


      </Row>
      {/* <div className="clinic-layout mt-4">
        <div className="clinic-col">
          <div className="clinic-input-title">
            {t("signUp.confirmPage.nameFull")}
          </div>
          <div className="clinic-input-value">{values.clinic_name}</div>
          <div className="clinic-input-title">
            {t("signUp.confirmPage.nameFuri")}
          </div>
          <div className="clinic-input-value">
            {values.clinic_name_furigana}
          </div>
          <div className="clinic-input-title mt-20">
            {t("signUp.confirmPage.address")}
          </div>
          <div className="clinic-row">
            <span>〒</span>
            <div className="clinic-input-value">
              {values.address?.postal_code}
            </div>
          </div>
          <div className="clinic-input-value">
            {PROVINCES_MAPPING[values.address?.province]}
            {values.address?.name}
          </div>
          <div className="clinic-input-value">{values.address?.building}</div>
        </div>
        <div className="clinic-col">
          <div className="clinic-input-title">
            {t("signUp.confirmPage.phone")}
          </div>
          <div className="clinic-row">
            <div className="clinic-input-value">{values.phone_number}</div>
          </div>
          <div className="clinic-input-title mt-20">
            {t("signUp.confirmPage.email")}
          </div>
          <div className="clinic-input-value">{values.email}</div>
          <div className="clinic-input-title mt-20">
            {t("signUp.confirmPage.password")}
          </div>
          <div className="clinic-input-value">**********</div>
        </div>
      </div> */}
      <div className="clinic-layout">
        <div className="form-value-footer-bottom">
          <div className="form-value-footer-button">
            <Button
              text={"新規登録"}
              className="submit-button"
              onClick={handleSubmit}
            />
          </div>
          <div className="form-value-footer-link" onClick={() => setScreen(0)}>
            {t("signUp.confirmPage.editButton")}
          </div>
        </div>
      </div>
      {isLoading && <Loading />}
    </div>
  );
};

export default ConfirmSignUp;
